class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  summaryHasLink() {
    return this.summary?.dataset.href && this.summary.dataset.href !== '#';
  }

  onSummaryClick(event) {
    if (!this.summaryHasLink()) return;
    const shouldNavigate = !this.mainDetailsToggle.hasAttribute('open');
    if (shouldNavigate) {
      window.location.assign(this.summary.dataset.href);
    }
  }

  onSummaryKeyDown(event) {
    if (!this.summaryHasLink()) return;
    if (event.key !== 'Enter') return;
    event.preventDefault();
    window.location.assign(this.summary.dataset.href);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle?.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.pointerFineMediaQuery = window.matchMedia('(hover: hover)');

    this.summary?.addEventListener('click', this.onSummaryClick.bind(this));
    this.summary?.addEventListener('keydown', this.onSummaryKeyDown.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  shouldOpenOnHover() {
    return this.desktopMediaQuery.matches && this.pointerFineMediaQuery.matches;
  }

  onMouseEnter() {
    if (!this.shouldOpenOnHover()) return;
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', true);
    this.summary?.setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.shouldOpenOnHover()) return;
    if (this.contains(document.activeElement)) return;
    super.close();
  }

  onSummaryClick(event) {
    if (!this.summaryHasLink()) return;

    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    if (this.shouldOpenOnHover() || isOpen) {
      event.preventDefault();
      window.location.assign(this.summary.dataset.href);
    }
  }

  onSummaryKeyDown(event) {
    if (!this.summaryHasLink()) return;
    if (event.key !== 'Enter') return;

    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    if (this.shouldOpenOnHover() || isOpen) {
      event.preventDefault();
      window.location.assign(this.summary.dataset.href);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
